import { Routes, Route, Navigate } from 'react-router-dom';
import { SignIn, useUser } from '@clerk/clerk-react';
import { Toaster } from 'react-hot-toast';
import Layout from './layouts/Layout';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import Analytics from './pages/Analytics';
import MedicalAnalytics from './pages/MedicalAnalytics';
import Errors from './pages/Errors';
import Database from './pages/Database';
import Settings from './pages/Settings';
import { trackRender } from './utils/debugRender';

function App() {
  const { isSignedIn, isLoaded } = useUser();

  // 🔍 DEBUG: Track App component renders
  trackRender('App', { isSignedIn, isLoaded });

  // Show loading while checking auth
  if (!isLoaded) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }

  // Show sign-in if not authenticated
  if (!isSignedIn) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold text-gray-900">PeeTrack Admin</h1>
            <p className="mt-2 text-gray-600">Sign in to access the admin dashboard</p>
          </div>
          <SignIn routing="path" path="/" />
        </div>
      </div>
    );
  }

  // Show admin dashboard
  return (
    <>
      <Toaster position="top-right" />
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/:userId" element={<UserDetail />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/medical" element={<MedicalAnalytics />} />
          <Route path="/errors" element={<Errors />} />
          <Route path="/database" element={<Database />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </>
  );
}

export default App;
